module.exports = __webpack_public_path__ + "img/Grupo 1675@2x.9553ab04.png";